import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import deployReservationCheck from '../../mixins/_deploy_reservation_check';
import imageSelecter from '../../components/_image_selecter';
import modalReserveDeployConfirm from '../../components/deploy/_modal_reserve_deploy_confirm';

/**
 * ページ一覧コンポーネント
 */
export default {
    name: 'pageList',
    template: '#page_list_template',
    data () {
        return {
            // 削除対象page
            selected_page: null,
            // 削除対象index
            selected_index: null,
        };
    },
    props: {
        // ページリスト
        pages: {
            type: Array,
            default: () => ([]),
            require: true,
        },
        // ページタイプ
        type: {
            type: String,
            required: true,
            validator: function (value) {
                return ['released', 'draft'].indexOf(value) !== -1;
            }
        }
    },
    computed: {
        // 公開中データか否か
        isReleased: function () {
            return (this.type === 'released');
        }
    },
    components: {
        // 画像の選択、UPロードを操作するコンポーネント
        'image-selecter': imageSelecter,
        // 反映予約確認モーダルコンポーネント
        'modal-reserve-deploy-confirm': modalReserveDeployConfirm,
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
        deployReservationCheck,
    ],
    emits: ['update:pages'],
    methods: {
        // idを取得
        getId: function (page) {
            return (this.isReleased) ? page.page_key : page.edit_id;
        },
        // 編集画面へ
        edit: function (page) {
            // 公開中
            if (this.isReleased) {
                window.location.href = '/custom_page/edit?page_key=' + page.page_key;
            // 下書き
            } else {
                window.location.href = '/custom_page/new?id=' + page.edit_id;
            }
        },
        // ページを開く
        openPage: function (page) {
            const url = this.$_yahooPageUrl(page.page_key);
            window.open(url, '_blank');
        },
        // コピー
        copy: function (page) {
            // 公開中
            if (this.isReleased) {
                window.location.href = '/custom_page/edit?copy=released&id=' + page.page_key;
            // 下書き
            } else {
                window.location.href = '/custom_page/new?copy=draft&id=' + page.edit_id;
            }
        },
        // 削除
        remove: async function (shouldPublish = true) {

            let message = this.exception_error_message;
            this.$_loading();
            try {
                const response = await yahooAxios.post('/custom_page/remove', {
                    id: this.getId(this.selected_page),
                    type: this.type,
                    should_publish: shouldPublish,
                });
                if (response.data.status == 'OK') {
                    // リストを更新
                    this.emitUpdatePages(this.selected_index);
                    swal('削除しました');
                    message = '';
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
        },
        // 削除前処理
        bereforRemove: async function (page, index) {

            if (!await swalConfirm(page.name + 'を削除します。よろしいですか？')) {
                return;
            }

            // 削除対象page, indexを保持
            this.selected_page = page;
            this.selected_index = index;

            try {
                // 反映予約有無をチェック
                const existsReservation = await this.existsDeployReservation();
                if(existsReservation) {
                    // 予約あり
                    this.$refs.modalReserveDeployConfirm.open();
                    return;
                }
                // 予約なし
                this.remove(true);

            } catch (e) {
                const message = this.getCatchMessage(e);
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    }, this.$parent);
                }
            }

        },
        // テンプレート設定モーダルを開く
        openTemplateConfig: function (index) {
            this.$root.$refs.templateConfigEditor.show(index);
        },

        // -------------------------
        // emit
        // -------------------------

        // リストを更新して親へ通知
        emitUpdatePages: function (index) {
            let pages = _.cloneDeep(this.pages);
            pages.splice(index, 1);
            this.$emit('update:pages', pages);
        }
    }
};
